

exports.__esModule = true;
exports.$xoSidebarAddShippingPageComponent = undefined;

var _angular = require('angular');

var _squid = require('squid');

var _uiRouter = require('uiRouter');

require('xo-member-components/src/select-shipping/directive');

require('xo-page-components/src/aside-header/directive');

require('xo-ui-components/src/dropdown/directive');

require('xo-validation/dist/directive');

var _template = require('./template');

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var $xoSidebarAddShippingPageComponent = exports.$xoSidebarAddShippingPageComponent = _squid.$Component.extend('$xoSidebarAddShippingPageComponent', {
    tag: 'xo-sidebar-add-shipping-page',
    template: _template2['default'],

    controller: ['$scope', function ($scope) {
        $scope.token = _angular.$rootScope.token;
        $scope.sidebar = true;

        $scope.onComplete = function () {
            _uiRouter.$state.go('checkout.review');
        };
    }]
});

angular.value("$xoSidebarAddShippingPageComponent", $xoSidebarAddShippingPageComponent);
_angular.$rootScope;

_squid.$Component;

_uiRouter.$state;


//////////////////
// WEBPACK FOOTER
// ./pages/xo-sidebar-add-shipping/directive.js
// module id = ./pages/xo-sidebar-add-shipping/directive.js
// module chunks = 0